import { facadeApi } from 'api'
import { WorkspaceAgency } from 'types/agencies/workspaceAgency'

export const fetchWorkspaceAgenciesApi = () => facadeApi.get<WorkspaceAgency[]>('/workspaces/agencies')
